export default {
  'menu.workbench': 'Workbench',
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.settings': 'Settings',
  'menu.settings.permissions': 'Permissions',
  'menu.settings.modelSettings': 'Model Settings',

  // EDI Hub
  'menu.dashboard': 'Dashboard',

  'menu.access': 'Access Management',
  'menu.access.partners': 'Partners',
  'menu.access.partnerDetail': 'Partner Detail',
  'menu.access.agreements': 'Exchange agreements',
  'menu.access.channels': 'Channels',
  'menu.access.connections': 'Connections',
  'menu.access.profiles': 'Local Protocol Profiles',
  'menu.access.certificates': 'Certificates & Keys',

  'menu.standards': 'Message Standards',
  'menu.standards.library': 'Standards Library',
  'menu.standards.standardDetail': 'Standard Detail',
  'menu.standards.dictionaries': 'Code Dictionaries',
  'menu.standards.documents': 'Business Documents',
  'menu.standards.documentDetail': 'Business Document',
  'menu.standards.mapping': 'Mappings',
  'menu.standards.mappingDesigner': 'Mapping Designer',

  'menu.workflow': 'Workflows',
  'menu.workflow.detail': 'Workflow Detail',
  'menu.workflow.flows': 'Business Flows',
  'menu.workflow.connections': 'System Connections',

  'menu.messages': 'Message Center',
  'menu.messages.query': 'Message Query',
  'menu.messages.interchanges': 'Interchanges',
  'menu.messages.documents': 'Reference Trace',
  'menu.messages.batch': 'Batch Processing',
  'menu.messages.archive': 'Archive & Storage',
  'menu.messages.detail': 'Message Detail',

  'menu.alerts': 'Monitoring & Alerts',
  'menu.alerts.events': 'Alert Events',
  'menu.alerts.rules': 'Alert Rules',
  'menu.alerts.workorders': 'Incident Workorders',
  'menu.alerts.knowledge': 'Knowledge Base',

  'menu.simulator': 'Simulation Tools',
  'menu.simulator.mock': 'Endpoint Mock',
  'menu.simulator.diagnose': 'Message Diagnosis',

  'menu.audit': 'Audit & Compliance',
  'menu.audit.logs': 'Operation Audit',
  'menu.audit.reports': 'Audit Reports',

  'menu.account': 'Account',
  'menu.account.center': 'User Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.logout': 'Logout',
};
